import React from 'react';
import {
    LISTING_STATE_CLOSED,
    LISTING_STATE_DRAFT,
    LISTING_STATE_PUBLISHED,
} from '../../../util/types';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import css from './ActionBarMaybe.css';
import { checkExternalListingFlow as external } from '../../../util/routes';

import { IconPenM, IconPlayCircleL } from '../../../icons';
import { useReactivateListing } from '../../../hooks/useReactivateListing';

const ActionBarButton = ({ listing, editParams }) => {
    const reactivateListing = useReactivateListing(listing);

    const { state } = listing.attributes;
    const isDraft = state === LISTING_STATE_DRAFT;
    const isPublished = state === LISTING_STATE_PUBLISHED;
    const isClosed = state === LISTING_STATE_CLOSED;
    const editListingRouteName = external(listing);

    if (isDraft || isPublished) {
        return (
            <NamedLink
                className={css.editListingLink}
                name={editListingRouteName}
                params={editParams}
            >
                <IconPenM />
                <FormattedMessage id={`ListingPage.actionBar-action-${state}`} />
            </NamedLink>
        );
    }
    if (isClosed) {
        return (
            <p className={css.editListingLink} onClick={reactivateListing}>
                <IconPlayCircleL />
                <FormattedMessage id={`ListingPage.actionBar-action-${state}`} />
            </p>
        );
    }
    return null;
};

export default ActionBarButton;
